import React from "react";

import TaskLayout from "./task";
import Attributes from "contexts/attributes/attributes";

const DuplicateStageLayout = ({ children }) => {
    return (
        <TaskLayout isDuplicateStage={true}>
            <Attributes>{children}</Attributes>
        </TaskLayout>
    );
};

export default DuplicateStageLayout;
